import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-indiana-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./indiana-state-form.component.html",
  styleUrl: "./indiana-state-form.component.scss",
})
export class IndianaStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
